import React, {
  memo,
  useCallback,
  useEffect,
  useState,
} from "react";
import { BrowserRouter as Router, Link, Redirect, Route } from "react-router-dom";
import "../css/Admin_css/admin-customize.css";
import COLORS from "../resources/colors/COLORS";
import axios from "axios";
import MyLoader from "../Spinner/MyLoader";
import SessionManager from "../Utils/SessionManager";
import myToast from "../Utils/MyToast";
import BackButton from "../ChildComponent/BackButton";
import StudentData from "./StudentData";

const API_BASE = () =>
  `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}`;

const PANEL_STYLE = {
  margin: "0 20px 20px",
  padding: "0",
};

const PAGE_TITLE_BAR_STYLE = {
  width: "100%",
  background: `linear-gradient(135deg, ${COLORS.primary_color_shade6} 0%, ${COLORS.primary_color_shade8} 100%)`,
  padding: "16px 24px",
  borderRadius: "8px 8px 0 0",
  boxShadow: `0 2px 4px ${COLORS.primary_color_shade3}`,
  marginTop: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexWrap: "wrap",
  gap: "10px",
};

const PAGE_TITLE_STYLE = {
  fontSize: "24px",
  fontWeight: "600",
  color: "#fff",
  margin: 0,
  display: "flex",
  alignItems: "center",
  gap: "10px",
};

const PANEL_BODY_STYLE = {
  padding: "20px 24px 30px",
  background: COLORS.primary_color_shade0,
};

const CARD_STYLES = {
  card: {
    borderRadius: "10px",
    border: `2px solid ${COLORS.primary_color_shade3}`,
    background: COLORS.white,
    padding: "14px 12px",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    transition: "all 0.2s ease",
    cursor: "pointer",
    boxShadow: `0 2px 6px ${COLORS.primary_color_shade2}44`,
    height: "100%",
  },
  iconWrap: {
    width: "52px",
    height: "52px",
    borderRadius: "50%",
    background: `linear-gradient(135deg, ${COLORS.primary_color_shade5} 0%, ${COLORS.primary_color_shade7} 100%)`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    boxShadow: `0 3px 8px ${COLORS.primary_color_shade4}55`,
  },
  content: {
    flex: 1,
    minWidth: 0,
  },
  title: {
    margin: 0,
    fontSize: "15px",
    fontWeight: "700",
    color: COLORS.primary_color_shade8,
    lineHeight: "1.3",
  },
  remark: {
    margin: "4px 0 0",
    fontSize: "12px",
    color: COLORS.primary_color_shade6,
    lineHeight: "1.35",
  },
  countBadge: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "32px",
    padding: "4px 12px",
    borderRadius: "20px",
    fontSize: "13px",
    fontWeight: "800",
    color: COLORS.primary_color_shade8,
    background: "rgba(255, 255, 255, 0.92)",
    border: "2px solid rgba(255, 255, 255, 0.65)",
    boxShadow: "0 1px 4px rgba(1, 87, 155, 0.2)",
  },
};

function PageHeader({ onBack }) {
  return (
    <div
      className="content-header"
      style={{ background: COLORS.primary_color_shade5 }}
    >
      <div className="leftside-content-header">
        <ul className="breadcrumbs">
          <li>
            <i
              className="fa fa-home"
              aria-hidden="true"
              style={{ color: COLORS.white }}
            />
            <span style={{ color: COLORS.white }}>Data Center</span>
          </li>
        </ul>
      </div>
      <div className="rightside-content-header">
        <BackButton onClick={onBack} />
      </div>
    </div>
  );
}

const DataCenterCard = memo(({ item }) => {
  const linkPath = `/AdminMain/StudentData/${item.data_id}`;

  return (
    <div style={{ padding: "8px" }}>
      <Link to={linkPath} style={{ textDecoration: "none" }}>
        <div
          style={CARD_STYLES.card}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-3px)";
            e.currentTarget.style.borderColor = COLORS.primary_color_shade5;
            e.currentTarget.style.boxShadow = `0 6px 14px ${COLORS.primary_color_shade4}66`;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.borderColor = COLORS.primary_color_shade3;
            e.currentTarget.style.boxShadow = `0 2px 6px ${COLORS.primary_color_shade2}44`;
          }}
        >
          <div style={CARD_STYLES.iconWrap}>
            <i
              className="fa fa-database"
              style={{ fontSize: "20px", color: COLORS.white }}
              aria-hidden="true"
            />
          </div>
          <div style={CARD_STYLES.content}>
            <h4 style={CARD_STYLES.title}>{item.data_caption}</h4>
            {item.data_remark ? (
              <p style={CARD_STYLES.remark}>{item.data_remark}</p>
            ) : null}
          </div>
          <i
            className="fa fa-chevron-right"
            aria-hidden="true"
            style={{
              color: COLORS.primary_color_shade5,
              fontSize: "14px",
              flexShrink: 0,
            }}
          />
        </div>
      </Link>
    </div>
  );
});

DataCenterCard.displayName = "DataCenterCard";

const DataCenterPage = memo(({ items, error, onRetry }) => {
  const handleBack = useCallback(() => {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = "/AdminMain";
    }
  }, []);

  if (error) {
    return (
      <div className="content" style={{ background: COLORS.whitesmoke }}>
        <PageHeader onBack={handleBack} />
        <div
          className="alert alert-danger"
          role="alert"
          style={{
            margin: "20px",
            paddingLeft: "30px",
            paddingRight: "30px",
          }}
        >
          <h4 className="alert-heading">Error Loading Data Center</h4>
          <p>{error}</p>
          <hr />
          <button className="btn btn-primary" onClick={onRetry}>
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="content" style={{ background: COLORS.whitesmoke }}>
      <PageHeader onBack={handleBack} />

      <div
        className="animated fadeInUp bg_page_white_rounded box_shadow"
        style={PANEL_STYLE}
      >
        <div style={PAGE_TITLE_BAR_STYLE}>
          <h3 style={PAGE_TITLE_STYLE}>
            <i className="fa fa-database" aria-hidden="true" style={{ color: "#fff" }} />
            Data Center
          </h3>
          {items.length > 0 ? (
            <span style={CARD_STYLES.countBadge}>{items.length}</span>
          ) : null}
        </div>

        <div style={PANEL_BODY_STYLE}>
          {items.length > 0 ? (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
                gap: "4px",
              }}
            >
              {items.map((item) => (
                <DataCenterCard
                  key={item.data_id || item.file_name}
                  item={item}
                />
              ))}
            </div>
          ) : (
            <div className="text-center py-5">
              <div
                style={{
                  width: "72px",
                  height: "72px",
                  margin: "0 auto 16px",
                  borderRadius: "50%",
                  background: `linear-gradient(135deg, ${COLORS.primary_color_shade2} 0%, ${COLORS.primary_color_shade4} 100%)`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: `0 4px 12px ${COLORS.primary_color_shade3}55`,
                }}
              >
                <i
                  className="fa fa-folder-open"
                  style={{ fontSize: "28px", color: COLORS.white }}
                  aria-hidden="true"
                />
              </div>
              <h5 style={{ color: COLORS.primary_color_shade8, fontWeight: "700" }}>
                No Data Center Items Available
              </h5>
              <p style={{ color: COLORS.primary_color_shade6, marginBottom: 0 }}>
                No data exports or reports are currently available.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
});

DataCenterPage.displayName = "DataCenterPage";

const DataCenter = () => {
  const [loggedIn] = useState(!!localStorage.getItem("token"));
  const [loading, setLoading] = useState(false);
  const [dataCenterItems, setDataCenterItems] = useState([]);
  const [error, setError] = useState(null);

  const fetchDataCenterMaster = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const schoolCode = SessionManager.getSchoolCode();
      const staffId = SessionManager.getStaffDetails().staff_id;
      const url = `${API_BASE()}getDataCenterMaster.php`;

      const response = await axios.get(url, {
        params: {
          staff_id: staffId,
          school_code: schoolCode,
        },
      });

      if (response.data.api_status === "OK") {
        setDataCenterItems(response.data.data || []);
      } else {
        const remark =
          response.data.api_remark || "Failed to load data center items.";
        setError(remark);
        myToast.notify_warning(remark);
      }
    } catch (err) {
      const errorMessage =
        err.response?.data?.api_remark ||
        err.response?.data?.message ||
        err.message ||
        "Failed to fetch data center items";
      setError(errorMessage);
      console.error("Error fetching data center:", err);
      myToast.notify_error(errorMessage);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchDataCenterMaster();
  }, [fetchDataCenterMaster]);

  if (!loggedIn) {
    return <Redirect to="/Login" />;
  }

  return (
    <Router>
      {loading && <MyLoader />}
      <Route
        path="/AdminMain/DataCenter"
        exact
        render={() => (
          <DataCenterPage
            items={dataCenterItems}
            error={error}
            onRetry={fetchDataCenterMaster}
          />
        )}
      />
      <Route
        path="/AdminMain/StudentData/:data_id"
        component={StudentData}
      />
    </Router>
  );
};

DataCenter.displayName = "DataCenter";

export default memo(DataCenter);
